import { render, staticRenderFns } from "./computingPower.vue?vue&type=template&id=0ebb4b0e&scoped=true"
import script from "./computingPower.vue?vue&type=script&lang=js"
export * from "./computingPower.vue?vue&type=script&lang=js"
import style0 from "./computingPower.vue?vue&type=style&index=0&id=0ebb4b0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebb4b0e",
  null
  
)

export default component.exports